// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1HourSchema } from './v1/hourSchema';
import { v1HoursCreateSchema } from './v1/hours/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createHourPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID where the time entry will be created"),
});

export const createHourHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Time entry created
 */
export const createHour201Schema = z.lazy(() => v1HourSchema);

/**
 * @description Unauthorized
 */
export const createHour401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Validation errors
 */
export const createHour422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createHourMutationRequestSchema = z.lazy(() => v1HoursCreateSchema);

export const createHourMutationResponseSchema = z.lazy(() => createHour201Schema);
